// Icônes SVG en ligne (aucun téléchargement). Trait = currentColor.
// Les classes "ico-*" sont animées par ui.css uniquement quand l'appareil est allumé.

const base = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.6,
  strokeLinecap: "round",
  strokeLinejoin: "round",
  "aria-hidden": true,
  focusable: "false",
};

export const BulbIcon = () => (
  <svg {...base}>
    <g className="ico-rays">
      <path d="M12 1.5v1.5M4.6 4.6l1.1 1.1M19.4 4.6l-1.1 1.1M2 11.5h1.5M20.5 11.5H22" />
    </g>
    <path className="ico-bulb-fill" d="M8.5 15.5a6 6 0 1 1 7 0c-.6.5-1 1.2-1 2V18h-5v-.5c0-.8-.4-1.5-1-2Z" />
    <path d="M9.5 20.5h5M10.5 22.5h3" />
  </svg>
);

export const LanternIcon = () => (
  <svg {...base}>
    <g className="ico-rays">
      <path d="M3.5 12H2M22 12h-1.5M5.5 6 4.5 5M18.5 6l1-1" />
    </g>
    <path d="M10 2.5h4M12 2.5v2" />
    <path className="ico-bulb-fill" d="M8 7.5 9.5 4.5h5L16 7.5v10.5l-1.5 2.5h-5L8 18Z" />
    <path d="M8 7.5h8M8 18h8" />
  </svg>
);

export const FountainIcon = () => (
  <svg {...base}>
    <path d="M12 14V7" />
    <path className="ico-drop" d="M12 7c-2.5 0-4 1.5-4.5 3.5" />
    <path className="ico-drop" d="M12 7c2.5 0 4 1.5 4.5 3.5" />
    <path d="M12 7V4.5" />
    <path d="M4 14h16l-1.5 4.5a2 2 0 0 1-1.9 1.5H7.4a2 2 0 0 1-1.9-1.5Z" />
  </svg>
);

export const BubblesIcon = () => (
  <svg {...base}>
    <g>
      <circle className="ico-bubble" cx="8" cy="9" r="1.6" />
      <circle className="ico-bubble" cx="13" cy="7" r="1.2" />
      <circle className="ico-bubble" cx="16.5" cy="10" r="1.4" />
    </g>
    <path d="M3 15c1.5 0 1.5-1 3-1s1.5 1 3 1 1.5-1 3-1 1.5 1 3 1 1.5-1 3-1 1.5 1 3 1" />
    <path d="M3 19c1.5 0 1.5-1 3-1s1.5 1 3 1 1.5-1 3-1 1.5 1 3 1 1.5-1 3-1 1.5 1 3 1" />
  </svg>
);

export const ProjectorIcon = () => (
  <svg {...base}>
    <path className="ico-beam" d="M15.5 9.5 22 6v9l-6.5-3.5" strokeOpacity="0.6" />
    <rect x="2" y="8" width="14" height="8" rx="2" />
    <circle cx="11.5" cy="12" r="2" />
    <path d="M5 19v-3M13 19v-3" />
  </svg>
);

export const AmbilightIcon = () => (
  <svg {...base}>
    <rect className="ico-glow" x="1.5" y="3.5" width="21" height="15" rx="3" strokeOpacity="0.45" strokeDasharray="2 2.5" />
    <rect x="4.5" y="6" width="15" height="10" rx="1.5" />
    <path d="M9 20.5h6" />
  </svg>
);

export const HeartIcon = () => (
  <svg {...base}>
    <path className="ico-heart" d="M12 20s-7.5-4.6-7.5-10A4.3 4.3 0 0 1 12 7.4 4.3 4.3 0 0 1 19.5 10c0 5.4-7.5 10-7.5 10Z" />
  </svg>
);

export const MoonIcon = () => (
  <svg {...base}>
    <path className="ico-moon" d="M20 14.5A8 8 0 1 1 9.5 4a6.5 6.5 0 0 0 10.5 10.5Z" />
    <path className="ico-rays" d="M16.5 3.5v2M15.5 4.5h2" />
  </svg>
);

export const SpeakerIcon = ({ muted }) => (
  <svg {...base}>
    <path d="M4 9.5h3.5L12 5.5v13l-4.5-4H4Z" />
    {muted ? (
      <path d="m16 9.5 5 5M21 9.5l-5 5" />
    ) : (
      <path d="M15.5 9a4 4 0 0 1 0 6M18 6.5a7.5 7.5 0 0 1 0 11" />
    )}
  </svg>
);

export const RemoteIcon = () => (
  <svg {...base}>
    <rect x="7" y="2" width="10" height="20" rx="3" />
    <circle cx="12" cy="8" r="2" />
    <path d="M10 13.5h.01M14 13.5h.01M10 16.5h.01M14 16.5h.01" strokeWidth="2.2" />
  </svg>
);

export const ArrowIcon = ({ dir }) => {
  const r = { up: 0, right: 90, down: 180, left: 270 }[dir];
  return (
    <svg {...base} style={{ transform: `rotate(${r}deg)` }}>
      <path d="m6 14 6-6 6 6" strokeWidth="2" />
    </svg>
  );
};

export const CloseIcon = () => (
  <svg {...base}>
    <path d="M6 6l12 12M18 6 6 18" strokeWidth="2" />
  </svg>
);

export const HomeIcon = () => (
  <svg {...base}>
    <path d="M4 11 12 4l8 7v8.5a1 1 0 0 1-1 1h-4.5v-6h-5v6H5a1 1 0 0 1-1-1Z" />
  </svg>
);

export const BackIcon = () => (
  <svg {...base}>
    <path d="M9 7 4.5 11.5 9 16" />
    <path d="M5 11.5h9.5a5 5 0 0 1 0 10H12" />
  </svg>
);

export const PlayPauseIcon = () => (
  <svg {...base}>
    <path d="M4 6v12l8-6Z" />
    <path d="M15.5 6v12M20 6v12" />
  </svg>
);

export const OfflineIcon = () => (
  <svg {...base}>
    <path d="M2 8.5a15 15 0 0 1 20 0M5.5 12a10 10 0 0 1 13 0M9 15.5a5 5 0 0 1 6 0" />
    <path d="M12 19h.01" strokeWidth="2.4" />
    <path d="M3 3l18 18" />
  </svg>
);

export const EyeOffIcon = () => (
  <svg {...base}>
    <path d="M3 3l18 18" />
    <path d="M10.6 5.1A9.7 9.7 0 0 1 12 5c6 0 9.5 7 9.5 7a16.6 16.6 0 0 1-3 3.8M6.6 6.6C3.9 8.4 2.5 12 2.5 12S6 19 12 19a9.6 9.6 0 0 0 5.4-1.6" />
    <path d="M9.9 9.9a3 3 0 0 0 4.2 4.2" />
  </svg>
);

// Thermomètre dont le niveau suit la température (20 °C → vide, 42 °C → plein)
export const Thermometer = ({ value }) => {
  const ratio = Math.min(1, Math.max(0, (value - 20) / 22));
  const h = 3 + ratio * 15;
  return (
    <svg viewBox="0 0 14 30" fill="none" stroke="currentColor" strokeWidth="1.4" aria-hidden="true" focusable="false">
      <path d="M4.5 19.5V4.5a2.5 2.5 0 0 1 5 0v15a4.5 4.5 0 1 1-5 0Z" />
      <rect className="thermo-level" x="6.2" y={21 - h} width="1.6" height={h} rx="0.8" fill="currentColor" stroke="none" />
      <circle cx="7" cy="23.3" r="2.6" fill="currentColor" stroke="none" />
    </svg>
  );
};
